import profile1 from "../assets/profile1.jpg"
import background1 from "../assets/bckg3.jpg"

  
  const Myprofiledetail = [
    {
        id: Math.random(),
        profileimg: profile1,
        postimg: background1,
        profilename: "Sam Lanson",
        jobTitle: "Web Developer",
        category: "first",
        desc: "I'd love to change the world, but they wont give me the source code.",
        post: 256,
        followers: 2.5,
        following:365,
    }
]

export default Myprofiledetail;